var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 18,
  viewBox: "0 0 11 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.883 11.016a3.045 3.045 0 0 1-.021-4.267L6.661.826l.57-.554a.9.9 0 0 1 1.355.076l1.647 2.013-5.447 5.857a1.063 1.063 0 0 0 .012 1.444l5.435 5.611-1.569 1.918a.99.99 0 0 1-1.4.14l-.603-.505z"
})));
export default SvgPinterestMobileBack;